const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export const formatDate = (
  date: string | Date | undefined | null,
  withEst: boolean = true,
): string => {
  if (!date) return withEst ? "Est. --" : "--";

  // new Date("YYYY-MM-DD") is UTC midnight, which displays as the previous day
  // west of UTC, so date-only values are read as local dates instead.
  const parsed =
    typeof date === "string" && DATE_ONLY.test(date)
      ? new Date(`${date}T00:00:00`)
      : new Date(date);

  const formatted = parsed.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return withEst ? `Est. ${formatted}` : formatted;
};

/**
 * A Date's calendar day as "YYYY-MM-DD" in the user's local timezone. Use this instead
 * of toISOString(), which returns the UTC date and can be a day off near local midnight.
 */
export const toLocalDateString = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

/** Today's date as "YYYY-MM-DD" in the user's local timezone. */
export const getLocalToday = (): string => toLocalDateString(new Date());

/**
 * "2024-01-15" | "2024-01-15T00:00:00.000Z" | "01/15/2024" → "2024-01-15".
 * Values already starting with a calendar date keep it, so no timezone can shift them.
 */
export const toDateOnly = (value: string): string | undefined => {
  const isoDay = value.match(/^\d{4}-\d{2}-\d{2}/);
  if (isoDay) return isoDay[0];
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? undefined : toLocalDateString(parsed);
};
